var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10 4 10 4 9.24 3C8.36 1.84 7.06 1 5.5 1C3.01 1 1 3.01 1 5.5C1 6.43 1.28 7.29 1.76 8C2.57 9.21 10 17 10 17M10 4C10 4 10 4 10.76 3C11.64 1.84 12.94 1 14.5 1C16.99 1 19 3.01 19 5.5C19 6.43 18.72 7.29 18.24 8C17.43 9.21 10 17 10 17",
    stroke: "#FDFDFD",
    strokeOpacity: 0.992157,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.97a5c87df6999590bcf67464af20c5c4.svg";
export { ForwardRef as ReactComponent };